require('./frontend/js/checkout/index');



